export default "__VITE_ASSET__03543d2f__"